<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Sneak Peek #{{ data.flow.id }}</h1>
		<div class="margin-top">
      <div

        v-if="data.flow.cancelled_at">
        Sneak Peek was cancelled
      </div>

      <div
        class="small-margin-top">
        <button
          :disabled="saving || !flowStarted"
          v-on:click="cancel"
          v-if="! data.flow.cancelled_at">Cancel</button>
        <button
          class="xs-margin-left"
          :disabled="!data.communication.step || saving || !flowStarted"
          v-on:click="communicate"
          v-if="! data.flow.cancelled_at">Communicate</button>
        <button
          class="xs-margin-left"
          :disabled="saving || !data.abandoned || !flowStarted"
          v-on:click="processAbandoned"
          v-if="! data.flow.cancelled_at">Process abandoned flow</button>
        <button
          class="xs-margin-left"
          :disabled="saving"
          v-on:click="goToSneakPeek"
          >Go to sneak peek</button>
      </div>

      <div v-if="flowStarted">
        <h3
        class="margin-top">Feedback given</h3>
        <Progress
          class="xs-margin-bottom"
          :progress="data.status.items_rated"
          :total="data.status.items_total"
        />
      </div>
      <div
        v-if="data.flow.feedback_given_at"
        class="note">
        Last given at
        <Format
          style="display: inline-block;"
          type="date"
          :time="true"
          :value="data.flow.feedback_given_at"
          />
      </div>
      <div v-if="flowStarted"
        class="margin-top">
        <h3>Timeline</h3>
        <div
          class="xs-margin-bottom flex"
          style="align-items: center;"
          v-for="row in timeline">
          <div
            style="width: 50px;">
            <SvgIcon
              :name="icon(row.key)" />
          </div>
          <div
            style="width: 110px">
            <Format
              type="date"
              :value="row.date"
              :time="true" />
          </div>
          <div
            style="padding-left: 30px;">
            {{ text(row.key) }}
          </div>
        </div>
      </div>

      <div
        v-if="data.tab"
        class="margin-top">
        <h3>Tab</h3>
        <div
          class="flex flex-vertical-center">
          <select
            :disabled="saving || data.tab.lock_tab == 1"
            v-model="data.tab.tab"
            v-on:change="setTab">
            <option value="">( Nothing )</option>
            <option value="sp">Ready</option>
            <option value="outstanding">Outstanding</option>
          </select>
          <div
            class="small-margin-left"
            v-if="data.tab.lock_tab">
            <SvgIcon
              :size="24"
              name="lock" />
          </div>
        </div>
      </div>

      <div v-if="flowStarted">
        <div
          class="margin-top">
          <h3>Technical details</h3>
        </div>

        <div
          class="margin-top">
          <div
            v-if="data.communication">
            <div
              class="flex xs-margin-bottom">
              <div
                class="small-margin-right"
                style="width: 280px; font-weight:  700;">Pending communication:
              </div>
              {{ data.communication.step }}
            </div>
          </div>
          <div
            class="flex xs-margin-bottom"
            v-for="(value, key) in data.flow">
            <div
              class="small-margin-right"
              style="width: 280px; font-weight:  700;">{{ key }}
            </div>
            {{ value }}
          </div>

          <div
            v-if="data.tab">
            <h3>Tab</h3>
            <div
              class="flex xs-margin-bottom"
              v-for="(value, key) in data.tab">
              <div
                class="small-margin-right"
                style="width: 280px; font-weight:  700;">{{ key }}
              </div>
              {{ value }}
            </div>
          </div>

          <div
            v-if="data.abandoned">
            <h3>Abandonment flow</h3>
            <div
              class="flex xs-margin-bottom"
              v-for="(value, key) in data.abandoned">
              <div
                class="small-margin-right"
                style="width: 280px; font-weight:  700;">{{ key }}
              </div>
              {{ value }}
            </div>
          </div>

        </div>
      </div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import da from 'vue2-datepicker/locale/es/da'

export default {
  data: () => ({
    loading: false,
    saving: false,
    data: {},
    timeline_fields: [
      ['flow', 'created_at'],
      ['flow', 'first_sms_sent_at'],
      ['flow', 'reminder_email_sent_at'],
      ['flow', 'cancellation_reminder_email_sent_at'],
      ['flow', 'cancelled_at'],
      ['abandoned', 'first_reminder_at'],
      ['abandoned', 'second_reminder_at'],
      ['abandoned', 'completed_at']
    ]
  }),
  watch: {
    '$route' () {
      this.load()
    }
  },
  computed: {
    timeline () {
      var list = []
      for (var i in this.timeline_fields) {
        const d = this.timeline_fields[i]
        if (!this.data[d[0]]) {
          continue
        }
        const val = this.data[d[0]][d[1]]
        if (!val) {
          continue
        }
        list.push({
          key: d[0] + '.' + d[1],
          date: val
        })
      }

      return list.sort((a, b) => a.date > b.date ? 1 : -1)
    },
    flowStarted () {
      return this.data.flow.flow !== null
    }
  },
  methods: {
    icon (text) {
      switch (text) {
        case 'flow.created_at':
          return 'create-column'
        case 'abandoned.completed_at':
          return 'done'
        case 'flow.cancelled_at':
          return 'delete'
        default:
          return 'email'
      }
    },
    text (text) {
      switch (text) {
        case 'flow.created_at':
          return 'Sneak Peek created'
        case 'flow.first_sms_sent_at':
          return 'Reminder / First'
        case 'flow.reminder_email_sent_at':
          return 'Reminder / Second'
        case 'flow.cancellation_reminder_email_sent_at':
          return 'Reminder / Cancellation warning'
        case 'flow.cancelled_at':
          return 'Reminder / Cancelled'
        case 'abandoned.first_reminder_at':
          return 'Abandoned / First'
        case 'abandoned.second_reminder_at':
          return 'Abandoned / Second'
        case 'abandoned.completed_at':
          return 'Abandoned / Completed'
        default:
          return text
      }
    },
    cancel () {
      if (!confirm('Are you sure?')) {
        return
      }

      Vue.$api.delete('/preshipping/' + this.$route.params.id, {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    communicate () {
      Vue.$api.post('/preshipping/' + this.$route.params.id + '/communicate', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    processAbandoned () {
      Vue.$api.post('/preshipping/abandoned/process/' + this.$route.params.id + '/', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    goToSneakPeek () {
      window.open(this.data.sneak_peek_link)
    },
    setTab () {
      const lock = confirm('Do you want to lock the tab?')

      Vue.$api.put('/preshipping/' + this.$route.params.id + '/tab', {
        lock_tab: lock,
        tab: this.data.tab.tab
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/preshipping/' + this.$route.params.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data
    }
  },
  created () {
    this.load()
  }
}
</script>
